import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '../../components/common/Typography';
import Badge from '../../components/common/Badge';
import HousingFundsCheckList from './HousingFundsCheckList';
import { setReload } from './eDocumentsSlice';
import { getAlertMessageFunction } from '../../common/Util';

const HousingFundsSection = ({ housingFundsStatus }) => {
  const dispatch = useDispatch();
  const isOpenInitial = {
    checkList: {
      type1: false,
      type2: false,
      type3: false,
      type4: false,
    },
  };
  const { t } = useTranslation('eDocuments');
  const { t: tHousingFunds } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const { htm013 } = useSelector(state => state.eDocuments);
  const [isOpen, setIsOpen] = useState({
    checkList: {
      type1: false,
      type2: false,
      type3: false,
      type4: false,
    },
  });

  const handleOpen = (type, detail) => {
    const alertMessage = getAlertMessageFunction();
    if (type == 'type3') {
      if (Number(htm013) > 70000000) {
        alertMessage(tCommon('alertMessage.alertMessage05'));
        return;
      }
    }
    if (type == 'type4') {
      if (Number(htm013) > 80000000) {
        alertMessage(tCommon('alertMessage.alertMessage19'));
        return;
      }
    }

    setIsOpen(prev => {
      isOpenInitial[detail][type] = true;
      return isOpenInitial;
    });
  };

  const onClose = () => {
    dispatch(setReload());
    setIsOpen(isOpenInitial);
  };

  return (
    <div className="housingFundsSection">
      <div className="backgroundBox"></div>
      <div className="displayFlex" style={{ justifyContent: 'flex-start', gap: '5px' }}>
        <Badge color="error" size="medium">
          {t('chips')}
        </Badge>
      </div>
      <Typography variant="subtitleMedium">{t('housingFundsSubtitle')}</Typography>
      {(Number(htm013) > 70000000 || Number(htm013) > 80000000) && (
        <div>
          {/* 총 급여 7000만원 초과 근로자로 월세액, 주택마련 불가 */}
          <Typography variant="body2Medium" color="GrayScale-700">
            {Number(htm013) > 80000000
              ? tHousingFunds('description.normal2')
              : tHousingFunds('description.normal1')}
            <span className="body2Bold">
              {/* 총 급여 8000만원 초과 근로자로 월세액, 주택마련 불가
                  총 급여 7000만원 초과 근로자로 주택마련
              */}
              {Number(htm013) > 80000000
                ? tHousingFunds('description.bold2')
                : tHousingFunds('description.bold1')}
            </span>
            <span className="body2Medium textGrayScale700">
              {tHousingFunds('description.normal3')}
            </span>
          </Typography>
        </div>
      )}
      <HousingFundsCheckList
        onOpen={handleOpen}
        onClose={onClose}
        isOpen={isOpen}
        housingFundsStatus={housingFundsStatus}
      />
    </div>
  );
};

export default HousingFundsSection;
